import { useEffect, useState, useRef, useCallback } from 'react';

const useClickAway = () => {
  const [isActive, setIsActive] = useState(false);

  const ref = useRef(null);

  function toggleIsActive() {
    setIsActive(!isActive);
  }

  const handleClick = useCallback(e => {
    if (!ref.current.contains(e.target)) setIsActive(false);
  }, []);

  useEffect(() => {
    if (isActive) document.addEventListener('mousedown', handleClick);
    else document.removeEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [isActive]);
  return { ref, isActive, setIsActive, toggleIsActive };
};

export default useClickAway;
